import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as m } from '../../constants/AccessibilityConstants';
import * as KeyboardConstants from '../../constants/Keyboard';
import * as KeyboardUtils from '../../lib/Keyboard';

import { ModalContainer } from './Modal';

import './Modal.scss';

const { element, node, func, oneOfType } = PropTypes;

export default class extends React.Component {
  static propTypes = {
    body: oneOfType([node, element, func]).isRequired,
  };

  state = {
    escKeyPressed: false,
  };

  componentDidMount() {
    this.bindKeyboardEvents();
  }

  componentWillUnmount() {
    this.unbindKeyboardEvents();
  }

  handleEsc = () => {
    this.setState({
      escKeyPressed: true,
    });
  };

  bindKeyboardEvents = () => {
    KeyboardUtils.bindKey({
      keySet: KeyboardConstants.KeySetKeys.MODAL,
      key: KeyboardConstants.MousetrapKeys.ESC,
      handler: this.handleEsc,
    });
  };

  unbindKeyboardEvents = () => {
    KeyboardUtils.unBindKey({
      keySet: KeyboardConstants.KeySetKeys.MODAL,
      key: KeyboardConstants.MousetrapKeys.ESC,
    });
  };

  render() {
    const { body: Body, ...props } = this.props;

    const focusTrapOptions = {
      escapeDeactivates: false,
    };

    return (
      <ModalContainer>
        <FocusTrap focusTrapOptions={focusTrapOptions}>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
          <p className='visuallyHidden' tabIndex='0'>
            <FormattedMessage {...m.menuTrapScreenReaderText} />{' '}
          </p>
          {React.isValidElement(Body) ? (
            Body
          ) : (
            <Body {...props} escKeyPressed={this.state.escKeyPressed} />
          )}
        </FocusTrap>
      </ModalContainer>
    );
  }
}
